const outsideClickListener = (event) => {
	const element = document.querySelector(
		".departaments__items-container.active"
	);

	if (!element) return;

	if (element !== event.target || !element.contains(event.target)) {
		const links = document.querySelectorAll(".departaments__items.hover");
		element.classList.remove("active");
		links.forEach((link) => link.classList.remove("hover"));
	}
};
const DepartmentsLinks = () => {
	const links = document.querySelectorAll(".departaments__items.has-children");
	links.forEach((link) => {
		link.addEventListener("click", (e) => {
			if (e.target.classList.contains("departaments__items-link")) {
				e.preventDefault();
				e.stopPropagation();

				const element = document.querySelector(
					".departaments__items-container.active"
				);
				const links = document.querySelectorAll(".departaments__items.hover");
				if (element) element.classList.remove("active");
				if (links) links.forEach((link) => link.classList.remove("hover"));

				const container = link.querySelector(".departaments__items-container");
				link.classList.toggle("hover", !link.classList.contains("hover"));
				container.classList.toggle(
					"active",
					!container.classList.contains("active")
				);
			}
		});
	});

	document.addEventListener("click", outsideClickListener);
};

document.addEventListener("DOMContentLoaded", () => {
	DepartmentsLinks();
});



function grabToSlide(slider) {
	let mouseDown = false;
	let startX, scrollLeft;
	const startDragging = (e) => {
		mouseDown = true;
		startX = e.pageX - slider.offsetLeft;
		scrollLeft = slider.scrollLeft;
	}

	const stopDragging = (e) => {
		mouseDown = false;
	}

	const move = (e) => {
		e.preventDefault();
		if (!mouseDown) { return; }
		const x = e.pageX - slider.offsetLeft;
		const scroll = x - startX;
		slider.scrollLeft = scrollLeft - scroll;
	}

	// Add the event listeners
	slider.addEventListener('mousemove', move, false);
	slider.addEventListener('mousedown', startDragging, false);
	slider.addEventListener('mouseup', stopDragging, false);
	slider.addEventListener('mouseleave', stopDragging, false);
}

window.addEventListener('DOMContentLoaded', () => {
	const sliders = document.querySelectorAll('.grab-to-slide');
	sliders.forEach((slider) => {
		grabToSlide(slider);
	});
})

function getOption(el) {
	let select = el;
	let atc = el.parentNode.querySelector('button');
	atc.setAttribute('onclick', `event.preventDefault();document.querySelector('ajax-cart').addToCart('${select.value}'), 1`)
}

document.addEventListener("DOMContentLoaded", function () {
	// Mobile menu JS start
	const body = $('body');
	const mobileMenu = $('.mobile-menu');
	const mobileMenuBody = mobileMenu.children('.mobile-menu__body');

	if (mobileMenu.length) {
		const open = function () {
			const bodyWidth = body.width();
			// body.css('overflow', 'hidden');
			body.css('paddingRight', (body.width() - bodyWidth) + 'px');

			mobileMenu.addClass('mobile-menu--open');
		};
		const close = function () {
			// body.css('overflow', 'auto');
			body.css('paddingRight', '');
			if ($(".mobile-menu__panel.active").length > 0) {
				$(".mobile-menu__panel-back", $(".mobile-menu__panel.active")).trigger('click');
			}
			mobileMenu.removeClass('mobile-menu--open');
		};

		$('.js-mobile-header-menu-button').on('click', function () {
			open();
		});
		$('.mobile-menu__backdrop, .mobile-menu__close').on('click', function () {
			close();
		});
	}

	const panelsStack = [];
	let currentPanel = mobileMenuBody.children('.mobile-menu__panel');

	mobileMenu.on('click', '[data-mobile-menu-trigger]', function (event) {
		const trigger = $(this);
		const item = trigger.closest('[data-mobile-menu-item]');
		let panel = item.data('panel');

		if (!panel) {
			panel = item.children('[data-mobile-menu-panel]').children('.mobile-menu__panel');

			if (panel.length) {
				mobileMenuBody.append(panel);
				item.data('panel', panel);
				panel.width(); // force reflow
			}
		}

		if (panel && panel.length) {
			event.preventDefault();

			panelsStack.push(currentPanel);
			currentPanel.addClass('mobile-menu__panel--hide');

			panel.removeClass('mobile-menu__panel--hidden');
			panel.addClass('active');
			currentPanel = panel;
		}
	});
	mobileMenu.on('click', '.mobile-menu__panel-back', function () {
		currentPanel.addClass('mobile-menu__panel--hidden');
		currentPanel.removeClass('active');
		currentPanel = panelsStack.pop();
		currentPanel.removeClass('mobile-menu__panel--hide');
	});
	// Mobile menu JS end

	// USP 2 Slider start
	$('.js-sp-usp-2').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 2000,
		fade: true
	});
	// USP 2 Slider end
})
